module.exports = {
    API_ENDPOINT: `https://secure-woodland-74305.herokuapp.com/api`,
    TOKEN_KEY: '',
}
